export const GET_TELLER_INFO = 'GET_TELLER_INFO'
